import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowRight, Package, Star, TrendingUp, MapPin } from "lucide-react";

const CreatePackage = () => {
  return (
    <div className="container mx-auto p-6" dir="rtl">
      {/* Breadcrumb */}
      <div className="flex items-center gap-2 mb-6 text-sm text-gray-600">
        <Link to="/tourism-packages" className="hover:text-blue-600">
          الباقات السياحية
        </Link>
        <span>/</span>
        <span className="text-gray-900">إنشاء باقة جديدة</span>
      </div>

      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">إنشاء باقة سياحية جديدة</h1>
          <p className="text-gray-600 mt-2">قم بإنشاء باقة سياحية متكاملة خطوة بخطوة</p>
        </div>
        <Link to="/tourism-packages">
          <Button variant="outline">
            <ArrowRight className="ml-2 h-4 w-4" />
            العودة للباقات
          </Button>
        </Link>
      </div>

      {/* Quick Start Options */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <Card className="cursor-pointer hover:shadow-lg transition-shadow border-2 hover:border-blue-500">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Package className="h-5 w-5 text-blue-600" />
              إنشاء من البداية
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-600">ابدأ بإنشاء باقة جديدة تماماً بخطوات مفصلة</p>
            <Link to="/create-package">
              <Button className="w-full mt-4 bg-blue-600 hover:bg-blue-700">
                ابدأ الآن
              </Button>
            </Link>
          </CardContent>
        </Card>

        <Card className="cursor-pointer hover:shadow-lg transition-shadow border-2 hover:border-green-500">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Star className="h-5 w-5 text-green-600" />
              استخدام قالب جاهز
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-600">اختر من مكتبة القوالب الجاهزة وعدّل عليها</p>
            <Button className="w-full mt-4 bg-green-600 hover:bg-green-700" disabled>
              قريباً
            </Button>
          </CardContent>
        </Card>

        <Card className="cursor-pointer hover:shadow-lg transition-shadow border-2 hover:border-purple-500">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <TrendingUp className="h-5 w-5 text-purple-600" />
              نسخ باقة موجودة
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-600">انسخ باقة موجودة وعدّل عليها حسب حاجتك</p>
            <Link to="/tourism-packages">
              <Button className="w-full mt-4 bg-purple-600 hover:bg-purple-700">
                اختر باقة
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>

      {/* Popular Destinations */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <MapPin className="h-5 w-5" />
            الوجهات الأكثر طلباً
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { name: 'تركيا', count: 45, image: '🇹🇷' },
              { name: 'ماليزيا', count: 32, image: '🇲🇾' },
              { name: 'إندونيسيا', count: 28, image: '🇮🇩' },
              { name: 'دبي', count: 25, image: '🇦🇪' },
              { name: 'مصر', count: 22, image: '🇪🇬' },
              { name: 'تايلاند', count: 18, image: '🇹🇭' },
              { name: 'المغرب', count: 15, image: '🇲🇦' },
              { name: 'البوسنة', count: 12, image: '🇧🇦' },
            ].map((dest) => (
              <div
                key={dest.name}
                className="p-4 border rounded-lg hover:border-blue-500 hover:shadow-md transition-all cursor-pointer"
              >
                <div className="text-4xl mb-2">{dest.image}</div>
                <p className="font-medium">{dest.name}</p>
                <p className="text-sm text-gray-600">{dest.count} باقة</p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* Tips */}
      <Card className="mt-6 bg-blue-50 border-blue-200">
        <CardContent className="pt-6">
          <h3 className="font-medium mb-2 text-blue-900">💡 نصائح لإنشاء باقة ناجحة:</h3>
          <ul className="space-y-2 text-sm text-blue-800">
            <li>• حدد الوجهة والمدة بدقة</li>
            <li>• أضف تفاصيل الفنادق والمرافق المتوفرة</li>
            <li>• وضّح الخدمات المشمولة وغير المشمولة</li>
            <li>• أضف صوراً جذابة للوجهة</li>
            <li>• حدد سعراً تنافسياً</li>
          </ul>
        </CardContent>
      </Card>
    </div>
  );
};

export default CreatePackage;